import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_YouthCatsScreening = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACTS_YouthCatsScreening' className='file-pdf-document'>
            <div className='file-template'>
<p className='w-750'><h3>Child and Adolescent Trauma Screen (CATS) - Youth Report</h3></p>
                
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Stressful or scary events happen to many people. Below is a list of stressful and scary events
                                that sometimes happen. Mark YES if it happened to you. Mark No if it didn`t happen to you.
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>1.
                        </td>
                        <td className='w-600'>Serious natural disaster like a flood, tornado, hurricane,
                            earthquake, or fire.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_Y_1" name="rbStressEventSeriousNaturalDisaster" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_N_1" name="rbStressEventSeriousNaturalDisaster" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>2.
                        </td>
                        <td className='w-600'>Serious accident or injury like a car/bike crash, dog bite,
                            sports injury.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_Y_2" name="rbStressEventSeriousInjuryCar" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_N_2" name="rbStressEventSeriousInjuryCar" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>3.
                        </td>
                        <td className='w-600'>Robbed by threat, force or weapon.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_Y_3" name="rbStressEventRobbedByThreat" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_N_3" name="rbStressEventRobbedByThreat" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>4.
                        </td>
                        <td className='w-600'>Slapped, punched, or beat up in your family
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_Y_4" name="rbStressEventSlappedPunchedBeatFamily" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_N_4" name="rbStressEventSlappedPunchedBeatFamily" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>5.
                        </td>
                        <td className='w-600'>Slapped, punched, or beat up by someone not in your
                            family.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_Y_5" name="rbStressEventSlappedPunchedBeat" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_N_5" name="rbStressEventSlappedPunchedBeat" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>6.
                        </td>
                        <td className='w-600'>Seeing someone in your family get slapped, punched or
                            beat up.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_Y_6" name="rbStressEventSeeingSomeoneFamily" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_N_6" name="rbStressEventSeeingSomeoneFamily" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>7.
                        </td>
                        <td className='w-600'>Seeing someone in the community get slapped, punched
                            or beat up.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_Y_7" name="rbStressEventSeeingSomeoneCommunity" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_N_7" name="rbStressEventSeeingSomeoneCommunity" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>8.
                        </td>
                        <td className='w-600'>Someone older touching your private parts when they
                            shouldn`t.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_Y_8" name="rbStressEventSomeoneOlderTouching" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_N_8" name="rbStressEventSomeoneOlderTouching" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>9.
                        </td>
                        <td className='w-600'>Someone forcing or pressuring sex, or when you couldn t
                            say no.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_Y_9" name="rbStressEventSomeoneForcingPressuringSex" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_N_9" name="rbStressEventSomeoneForcingPressuringSex" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>10.
                        </td>
                        <td className='w-600'>Someone close to you dying suddenly or violently.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_Y_10" name="rbStressEventSomeoneCloseDyingSuddenly" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_N_10" name="rbStressEventSomeoneCloseDyingSuddenly" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>11.
                        </td>
                        <td className='w-600'>Attacked, stabbed, shot at or hurt badly.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_Y_11" name="rbStressEventAttackedStabbedShotHurt" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_N_11" name="rbStressEventAttackedStabbedShotHurt" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>12.
                        </td>
                        <td className='w-600'>Seeing someone attacked, stabbed, shot at, hurt badly or
                            killed.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_Y_12" name="rbStressEventSeeigSomeoneHurtBadly" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_N_12" name="rbStressEventSeeigSomeoneHurtBadly" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>13.
                        </td>
                        <td className='w-600'>Stressful or scary medical procedure.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_Y_13" name="rbStressEventStressfulScaryMedicaal" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_N_13" name="rbStressEventStressfulScaryMedicaal" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>14.
                        </td>
                        <td className='w-600'>Being around war.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_Y_14" name="rbStressEventBeingAroundWar" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_N_14" name="rbStressEventBeingAroundWar" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>15.
                        </td>
                        <td className='w-600'>Other stressful or scary event?
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_Y_15" name="rbStressEventOtherStressfulScary" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStressEvent_N_15" name="rbStressEventOtherStressfulScary" className='add-only' value="No" /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Describe:</span>
                    <textarea id="txtDescribeStress" name="txtDescribeStress" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Which one is bothering you the most now?</span>
                    <textarea id="txtOneBother" name="txtOneBother" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <strong>If you marked "YES" to any stressful or scary events, then turn the page and
                        answer the next questions.
                    </strong>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <strong>Mark 0, 1, 2 or 3 for how often the following things have bothered you in the last two
                                weeks:
                            </strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>0 = Never
                        </td>
                        <td className='w-187'>1 = Once in a while
                        </td>
                        <td className='w-187'>2 =  Half the time
                        </td>
                        <td className='w-187'>3 =  Almost always
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-50'>&nbsp;
                        </td>
                        <td className='w-500'>&nbsp;
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>0
                            </span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>1
                            </span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>2
                            </span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>3
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>1.</td>
                        <td className='w-500'>Upsetting thoughts or pictures about what happened that pop into your head.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbUpsetting_0" name="rbUpsettingThoughtsPicture" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbUpsetting_1" name="rbUpsettingThoughtsPicture" className='add-only' value="2" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbUpsetting_2" name="rbUpsettingThoughtsPicture" className='add-only' value="3" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbUpsetting_3" name="rbUpsettingThoughtsPicture" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>2.</td>
                        <td className='w-500'>Bad dreams reminding you of what happened.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbBadDreams_0" name="rbBadDreamsRemindingYou" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbBadDreams_1" name="rbBadDreamsRemindingYou" className='add-only' value="2" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbBadDreams_2" name="rbBadDreamsRemindingYou" className='add-only' value="3" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbBadDreams_3" name="rbBadDreamsRemindingYou" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>3.</td>
                        <td className='w-500'>Feeling as if what happened is happening all over again.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFeelingHappen_0" name="rbFeelingHappenHappeningAll" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFeelingHappen_1" name="rbFeelingHappenHappeningAll" className='add-only' value="2" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFeelingHappen_2" name="rbFeelingHappenHappeningAll" className='add-only' value="3" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFeelingHappen_3" name="rbFeelingHappenHappeningAll" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>4.</td>
                        <td className='w-500'>Feeling very upset when you are reminded of what happened.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFeelingUpset_0" name="rbFeelingUpsetWhenYouReminded" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFeelingUpset_1" name="rbFeelingUpsetWhenYouReminded" className='add-only' value="2" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFeelingUpset_2" name="rbFeelingUpsetWhenYouReminded" className='add-only' value="3" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFeelingUpset_3" name="rbFeelingUpsetWhenYouReminded" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>5.</td>
                        <td className='w-500'>Strong feelings in your body when you are reminded of what happened (sweating,
                            heart beating fast, upset stomach).
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFeelingStrong_0" name="rbFeelingStrongRemindedHappenedSweating" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFeelingStrong_1" name="rbFeelingStrongRemindedHappenedSweating" className='add-only' value="2" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFeelingStrong_2" name="rbFeelingStrongRemindedHappenedSweating" className='add-only' value="3" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFeelingStrong_3" name="rbFeelingStrongRemindedHappenedSweating" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>6.</td>
                        <td className='w-500'>Trying not to think about or talk about what happened. Or to not have feelings
                            about it.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFeelingTry_0" name="rbFeelingTryAboutItTalk" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFeelingTry_1" name="rbFeelingTryAboutItTalk" className='add-only' value="2" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFeelingTry_2" name="rbFeelingTryAboutItTalk" className='add-only' value="3" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFeelingTry_3" name="rbFeelingTryAboutItTalk" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>7.</td>
                        <td className='w-500'>Staying away from people, places, things, or situations that remind you of what
                            happened.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStayPeople_0" name="rbStayPeoplePlacesThingsSituation" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStayPeople_1" name="rbStayPeoplePlacesThingsSituation" className='add-only' value="2" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStayPeople_2" name="rbStayPeoplePlacesThingsSituation" className='add-only' value="3" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbStayPeople_3" name="rbStayPeoplePlacesThingsSituation" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>8.</td>
                        <td className='w-500'>Not being able to remember part of what happened.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbRememberPart_0" name="rbRememberPartWhatHappened" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbRememberPart_1" name="rbRememberPartWhatHappened" className='add-only' value="2" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbRememberPart_2" name="rbRememberPartWhatHappened" className='add-only' value="3" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbRememberPart_3" name="rbRememberPartWhatHappened" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>9.</td>
                        <td className='w-500'>Negative thoughts about yourself or others. Thoughts like I won t have a good life,
                            no one can be trusted, the whole world is unsafe.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbNegativeThoughts_0" name="rbNegativeThoughtsThoughtsLikeGoodLifeWe" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbNegativeThoughts_1" name="rbNegativeThoughtsThoughtsLikeGoodLifeWe" className='add-only' value="2" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbNegativeThoughts_2" name="rbNegativeThoughtsThoughtsLikeGoodLifeWe" className='add-only' value="3" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbNegativeThoughts_3" name="rbNegativeThoughtsThoughtsLikeGoodLifeWe" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>10.</td>
                        <td className='w-500'>Blaming yourself for what happened, or blaming someone else when it isn`t their
                            fault.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbBlamingFault_0" name="rbBlamingFaultHappendedBlaming" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbBlamingFault_1" name="rbBlamingFaultHappendedBlaming" className='add-only' value="2" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbBlamingFault_2" name="rbBlamingFaultHappendedBlaming" className='add-only' value="3" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbBlamingFault_3" name="rbBlamingFaultHappendedBlaming" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>11.</td>
                        <td className='w-500'>Bad feelings (afraid, angry, guilty, ashamed) a lot of the time
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbBadFeel_0" name="rbBadFeelAfraidAnfryGuilty" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbBadFeel_1" name="rbBadFeelAfraidAnfryGuilty" className='add-only' value="2" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbBadFeel_2" name="rbBadFeelAfraidAnfryGuilty" className='add-only' value="3" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbBadFeel_3" name="rbBadFeelAfraidAnfryGuilty" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>12.</td>
                        <td className='w-500'>Not wanting to do things you used to do.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbNotWant_0" name="rbNotWantThingsYouUsesTo" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbNotWant_1" name="rbNotWantThingsYouUsesTo" className='add-only' value="2" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbNotWant_2" name="rbNotWantThingsYouUsesTo" className='add-only' value="3" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbNotWant_3" name="rbNotWantThingsYouUsesTo" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>13.</td>
                        <td className='w-500'>Not feeling close to people.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbNotFeel_0" name="rbNotFeelFellingClosePeople" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbNotFeel_1" name="rbNotFeelFellingClosePeople" className='add-only' value="2" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbNotFeel_2" name="rbNotFeelFellingClosePeople" className='add-only' value="3" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbNotFeel_3" name="rbNotFeelFellingClosePeople" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>14.</td>
                        <td className='w-500'>Not being able to have good or happy feelings.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbNotGood_0" name="rbNotGoodAbleToHaveHappyFeeling" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbNotGood_1" name="rbNotGoodAbleToHaveHappyFeeling" className='add-only' value="2" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbNotGood_2" name="rbNotGoodAbleToHaveHappyFeeling" className='add-only' value="3" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbNotGood_3" name="rbNotGoodAbleToHaveHappyFeeling" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>15.</td>
                        <td className='w-500'>Feeling mad. Having fits of anger and taking it out on others
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFeelMad_0" name="rbFeelMadHavingFitsAngerTakingOthers" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFeelMad_1" name="rbFeelMadHavingFitsAngerTakingOthers" className='add-only' value="2" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFeelMad_2" name="rbFeelMadHavingFitsAngerTakingOthers" className='add-only' value="3" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFeelMad_3" name="rbFeelMadHavingFitsAngerTakingOthers" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>16.</td>
                        <td className='w-500'>Doing unsafe things.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbDoUnsafe_0" name="rbDoUnsafeDoingThings" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbDoUnsafe_1" name="rbDoUnsafeDoingThings" className='add-only' value="2" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbDoUnsafe_2" name="rbDoUnsafeDoingThings" className='add-only' value="3" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbDoUnsafe_3" name="rbDoUnsafeDoingThings" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>17.</td>
                        <td className='w-500'>Being overly careful or on guard (checking to see who is around you).
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbBeCareful_0" name="rbBeCarefulBeingOverlyGuard" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbBeCareful_1" name="rbBeCarefulBeingOverlyGuard" className='add-only' value="2" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbBeCareful_2" name="rbBeCarefulBeingOverlyGuard" className='add-only' value="3" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbBeCareful_3" name="rbBeCarefulBeingOverlyGuard" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>18.</td>
                        <td className='w-500'>Being jumpy
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbBeJumpy_0" name="rbBeJumpyBeing" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbBeJumpy_1" name="rbBeJumpyBeing" className='add-only' value="2" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbBeJumpy_2" name="rbBeJumpyBeing" className='add-only' value="3" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbBeJumpy_3" name="rbBeJumpyBeing" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>19.</td>
                        <td className='w-500'>Problems paying attention.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbProbPay_0" name="rbProbPayProblemAttendion" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbProbPay_1" name="rbProbPayProblemAttendion" className='add-only' value="2" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbProbPay_2" name="rbProbPayProblemAttendion" className='add-only' value="3" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbProbPay_3" name="rbProbPayProblemAttendion" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>20.</td>
                        <td className='w-500'>Trouble falling or staying asleep.
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTroubleSleep_0" name="rbTroubleSleepStayingSleep" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTroubleSleep_1" name="rbTroubleSleepStayingSleep" className='add-only' value="2" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTroubleSleep_2" name="rbTroubleSleepStayingSleep" className='add-only' value="3" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTroubleSleep_3" name="rbTroubleSleepStayingSleep" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>&nbsp;
                        </td>
                        <td className='w-100'>Total Score=
                        </td>
                        <td className='w-100'>
                            <input type="text" name="txtTotalScore" id="txtTotalScore" className='add-only'   />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>&nbsp;
                        </td>
                        <td className='w-100'>Clinical=
                        </td>
                        <td className='w-100'>15+
                            <input type="text" name="txtClinical" id="txtClinical" className='add-only'   />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Please mark "YES" or "NO" if the problems you marked interfered with:
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>1.
                        </td>
                        <td className='w-250'>Getting along with others
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbGetAlong_Y_1" name="rbGetAlongOther" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbGetAlong_N_1" name="rbGetAlongOther" className='add-only' value="No" /> No
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>2.
                        </td>
                        <td className='w-250'>Hobbies/Fun
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbHobbies_Y_1" name="rbHobbiesFuns" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbHobbies_N_1" name="rbHobbiesFuns" className='add-only' value="No" /> No
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>3.
                        </td>
                        <td className='w-250'>School or work
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbSchoolWork_Y_1" name="rbSchoolWorkWorkNeed" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbSchoolWork_N_1" name="rbSchoolWorkWorkNeed" className='add-only' value="No" /> No
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>4.
                        </td>
                        <td className='w-250'>Family relationships
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFamilyRelation_Y_1" name="rbFamilyRelatioFamily" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFamilyRelation_N_1" name="rbFamilyRelatioFamily" className='add-only' value="No" /> No
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>5.
                        </td>
                        <td className='w-250'>General happiness
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbGeneralHap_Y_1" name="rbGeneralHapHappySad" className='add-only' value="Yes" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbGeneralHap_N_1" name="rbGeneralHapHappySad" className='add-only' value="No" /> No
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                </table> 

            </div>
        </form>

    )
}  
